import React from 'react';

const Loader = () => {
	return (
		<div className='app-loader' role='status' aria-label='加载中'>
			{/* 简洁快速的三点跳动加载动画 */}
			<div className='app-loader__dots'>
				<div className='app-loader__dot' />
				<div className='app-loader__dot' />
				<div className='app-loader__dot' />
			</div>
		</div>
	);
};

export const RouteFallback = () => (
	<div className='app-route-fallback' role='status' aria-label='加载中'>
		<Loader />
	</div>
);

export default Loader;
